import React from "react";
import { Divider, Grid, ListItem } from "@mui/material";
import { BooleanInput, FormDataConsumer, NumberInput } from "react-admin";
import {
  canFieldBeHidden,
  filterFieldBasedOnName,
  showLargeItemInput,
  showLargeItemInputForBundle,
} from "../../utils/CreateReportUtils";
import { useFormContext, useWatch } from 'react-hook-form';
import { isFeatureEnabled } from "../DataProvider";
import { CLIENT_DEFAULT_PARAMS, ENABLED_FEATURES_ENUM } from "../Constants";
import {
  positiveValue,
  validate,
} from "../../utils/util";
import isEmpty from "lodash/isEmpty";
import { largeItem, padding2, removeNumberArrowsStyle, textColor, width } from '../Styles'

export const LargeItemDynamicInput = (props) => {
  const values = useWatch();
  const form = useFormContext();

  const { largeItemField } = props;
  const incomeField = !isEmpty(largeItemField?.possibleValues) ? filterFieldBasedOnName("largeItemIncome", largeItemField?.possibleValues) : undefined;
  const expenseField = !isEmpty(largeItemField?.possibleValues) ? filterFieldBasedOnName("largeItemExpense", largeItemField?.possibleValues) : undefined;
  let incomeThresholdField = !isEmpty(incomeField?.possibleValues) ? filterFieldBasedOnName("largeItemIncomeThreshold", incomeField?.possibleValues) : undefined;
  let expenseThresholdField = !isEmpty(expenseField?.possibleValues) ? filterFieldBasedOnName("largeItemExpenseThreshold", expenseField?.possibleValues) : undefined;
  const [clientDefaultsMap, setClientDefaultsMap] = React.useState(new Map());

  React.useEffect(() => {
    let data = localStorage.getItem("clientDefaults");
    let defaultsMap = new Map();
    JSON.parse(data).forEach(param => {
      defaultsMap.set(CLIENT_DEFAULT_PARAMS[param.parameterKey], param.value)
    });
    setClientDefaultsMap(defaultsMap);
  }, []);

  React.useEffect(() => {//crs-hook
    (showLargeItemInput(values.reportType) || showLargeItemInputForBundle(values.multiReportType)) &&
      isFeatureEnabled(ENABLED_FEATURES_ENUM.GROUPING_LARGE_ITEM) // cleaning form on case of template and report change
      ? form.setValue("largeItem", largeItemField?.defaultValue)
      : form.setValue("largeItem", false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.reportType, JSON.stringify(values.multiReportType), props.selectedTemplateId, largeItemField]);
  
  React.useEffect(() => {//crs-hook
    if (
      (showLargeItemInput(values.reportType) || showLargeItemInputForBundle(values.multiReportType)) &&
      isFeatureEnabled(ENABLED_FEATURES_ENUM.GROUPING_LARGE_ITEM)
    ) {
      // cleaning form on case of template and report change
      form.setValue("largeItemIncome", incomeField?.defaultValue);
      form.setValue("largeItemExpense", expenseField?.defaultValue);
      form.setValue("largeItemIncomeThreshold", incomeThresholdField?.defaultValue ?? clientDefaultsMap.get(CLIENT_DEFAULT_PARAMS.LARGE_ITEM_GROUP_INCOME));
      form.setValue("largeItemExpenseThreshold", expenseThresholdField?.defaultValue ?? clientDefaultsMap.get(CLIENT_DEFAULT_PARAMS.LARGE_ITEM_GROUP_EXPENSE));
    } else {
      form.setValue("largeItemIncome", false);
      form.setValue("largeItemExpense", false);
      form.setValue("largeItemIncomeThreshold", undefined);
      form.setValue("largeItemExpenseThreshold", undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps    
    JSON.stringify(values.multiReportType),
    values.reportType,    
    values.selectedTemplateId,
    incomeField, 
    expenseField, 
    incomeThresholdField, 
    expenseThresholdField, 
    clientDefaultsMap]);

  return (
    (showLargeItemInput(values.reportType) || showLargeItemInputForBundle(values.multiReportType)) &&
    isFeatureEnabled(ENABLED_FEATURES_ENUM.GROUPING_LARGE_ITEM) && (
      <>
        <div style={largeItemField?.isHidden ? { display: "none" } : {}}>
          <ListItem sx={padding2.y}>
            <Grid container alignItems="center">
              <Grid xs={12} md={4} sx={textColor.gray}>
                {largeItemField?.displayName
                  ? largeItemField.displayName
                  : "Large Item"}
              </Grid>
              <Grid xs={12} md={8}>
                <BooleanInput
                  id="reports-create-large-item-toggle"
                  defaultValue={largeItemField?.defaultValue}
                  source="largeItem"
                  label={false}
                  sx={{ marginBottom: "-15px" }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider light />
        </div>
        <LargeItemCategory
          incomeField={incomeField}
          expenseField={expenseField}
          incomeThresholdField={incomeThresholdField}
          expenseThresholdField={expenseThresholdField}
          clientDefaultsMap={clientDefaultsMap}
        />
      </>
    )
  );
};

const LargeItemCategory = (props) => { 

  const { incomeField, expenseField, clientDefaultsMap } = props;
  let { incomeThresholdField, expenseThresholdField } = props;

  //Hide the child input(Threshold) if parent input(Category) is hidden with defaultValue false.
  if (incomeField) {
    if (incomeField.isHidden && incomeField.defaultValue !== true) {
      if (incomeThresholdField) {
        incomeThresholdField.isHidden = true;
      } else {
        incomeThresholdField = { isHidden: true }
      }
    }
  }

  if (expenseField) {
    if (expenseField.isHidden && expenseField.defaultValue !== true) {
      if (expenseThresholdField) {
        expenseThresholdField.isHidden = true;
      } else {
        expenseThresholdField = { isHidden: true }
      }
    }
  }

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) =>
        formData.largeItem && (
          <>
            { //hiding the category block when all items are hidden
              (<div style={(incomeField?.isHidden && expenseField?.isHidden && incomeThresholdField?.isHidden && expenseThresholdField?.isHidden) ? { display: "none" } : {}}>
                <ListItem sx={padding2.y}>
                  <Grid container>
                    <Grid item xs={12} md={4}></Grid>
                    <Grid item xs={12} md={6} lg={5}>
                      <Grid container>
                        <Grid item xs={12} md={5}>
                          <Grid sx={incomeField?.isHidden ? { display: "none" } : {}}>
                            <BooleanInput
                              id="reports-create-large-item-income-toggle"
                              sx={largeItem}
                              source="largeItemIncome"
                              label={
                                incomeField?.displayName
                                  ? incomeField.displayName
                                  : "Income"
                              }
                              defaultValue={incomeField?.defaultValue}
                            />
                          </Grid>
                        </Grid>
                        {formData?.largeItemIncome && (
                          <Grid item xs={12} md={7} >
                            <NumberInput
                              source="largeItemIncomeThreshold"
                              label={
                                incomeThresholdField?.placeholder
                                  ? incomeThresholdField.placeholder
                                  : "Threshold"
                              }
                              variant="outlined"
                              validate={[validate, positiveValue]}
                              defaultValue={
                                incomeThresholdField?.defaultValue ??
                                clientDefaultsMap.get(CLIENT_DEFAULT_PARAMS.LARGE_ITEM_GROUP_INCOME)
                              }
                              onWheel={(e) => {
                                e.target.blur();
                              }}
                              sx={{
                                ...removeNumberArrowsStyle,
                                ...width.fluid.w100,
                                ...(incomeThresholdField && canFieldBeHidden(
                                  incomeThresholdField?.isHidden,
                                  true,
                                  incomeThresholdField?.defaultValue ??
                                  clientDefaultsMap.get(CLIENT_DEFAULT_PARAMS.LARGE_ITEM_GROUP_INCOME)
                                ) ? { display: "none" } : {})
                              }}
                              disabled={
                                incomeThresholdField &&
                                canFieldBeHidden(
                                  incomeThresholdField?.disabled,
                                  true,
                                  incomeThresholdField?.defaultValue ??
                                  clientDefaultsMap.get(CLIENT_DEFAULT_PARAMS.LARGE_ITEM_GROUP_INCOME)
                                )
                              }
                            />
                          </Grid>
                        )}
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} md={5}>
                          <Grid sx={expenseField?.isHidden ? { display: "none" } : {}}>
                            <BooleanInput
                              id="reports-create-large-item-expense-toggle"
                              sx={largeItem}
                              source="largeItemExpense"
                              label={
                                expenseField?.displayName
                                  ? expenseField.displayName
                                  : "Expense"
                              }
                              defaultValue={expenseField?.defaultValue}

                            />
                          </Grid>
                        </Grid>
                        {formData?.largeItemExpense && (
                          <Grid item xs={12} md={7}>
                            <NumberInput
                              source="largeItemExpenseThreshold"
                              label={
                                expenseThresholdField?.placeholder
                                  ? expenseThresholdField.placeholder
                                  : "Threshold"
                              }
                              variant="outlined"
                              validate={[validate, positiveValue]}
                              defaultValue={
                                expenseThresholdField?.defaultValue ??
                                clientDefaultsMap.get(CLIENT_DEFAULT_PARAMS.LARGE_ITEM_GROUP_EXPENSE)
                              }
                              onWheel={(e) => {
                                e.target.blur();
                              }}
                              sx={{
                                ...removeNumberArrowsStyle,
                                ...width.fluid.w100,
                                ...(expenseThresholdField && canFieldBeHidden(
                                  expenseThresholdField?.isHidden,
                                  true,
                                  expenseThresholdField?.defaultValue ??
                                  clientDefaultsMap.get(CLIENT_DEFAULT_PARAMS.LARGE_ITEM_GROUP_EXPENSE)
                                ) ? { display: "none" } : {})
                              }}
                              disabled={
                                expenseThresholdField &&
                                canFieldBeHidden(
                                  expenseThresholdField?.disabled,
                                  true,
                                  expenseThresholdField?.defaultValue ??
                                  clientDefaultsMap.get(CLIENT_DEFAULT_PARAMS.LARGE_ITEM_GROUP_EXPENSE)
                                )
                              }
                            />
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider light />
              </div>)}
          </>
        )
      }
    </FormDataConsumer>
  );
};